import Page from '../Page';
import {useEffect} from 'preact/hooks';
import {useLocation} from 'preact-iso';
import {productPath} from '../productRoutes';

export default function ProductLinkPage() {
  const location = useLocation();
  const productId = location.query.id || location.query['ids[]'];

  useEffect(() => {
    if (productId) location.route(productPath(productId), true);
  }, [location, productId]);

  return (
    <Page heading="Product configuration">
      {productId
        ? <s-spinner accessibilityLabel="Opening product configuration" />
        : <s-banner tone="critical">Shopify did not provide a product ID for this action.</s-banner>}
    </Page>
  );
}
